// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xffzcx-index-main_right_content-3_Ies","table":"components-tjcx-xffzcx-index-table-1VxlB"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xffzcx/index.css
// module id = 2319
// module chunks = 0